export function setUserClient(
  permissions, userId, clientId, contactId,
  approveId1, approveId2, locationId, bu,
  deposit, deliveryCode, clientWithdraw,
) {
  const {
    cart, sphere, spot, clientCode,
    price, crossSelling, leadTime, stock,
    panel, similarity, purchaseEstimate,
    purchaseBilling, purchaseBankSlip,
    purchaseDebit, purchaseCredit,
    purchase, cartUsers, email, opicCode,
    soneparCode, visualizeAllOrders,
    purchasePaymentGateway, managerEmail,
    allowMixedPurchase,
  } = permissions;

  return {
    userId,
    clientId,
    contactId,
    cartPermission: cart,
    approveId1,
    approveId2,
    locationId,
    bu,
    deposit,
    deliveryCode,
    clientWithdraw,
    cartUsersPermission: cartUsers,
    purchasePermission: purchase,
    purchaseCreditPermission: purchaseCredit,
    purchaseDebitPermission: purchaseDebit,
    purchaseBankSlipPermission: purchaseBankSlip,
    purchaseBillingPermission: purchaseBilling,
    purchaseEstimatePermission: purchaseEstimate,
    purchasePaymentGateway,
    similarityPermission: similarity,
    panelPermission: panel,
    stockPermission: stock,
    leadTimePermission: leadTime,
    crossSellingPermission: crossSelling,
    pricePermission: price,
    clientCodePermission: clientCode,
    spherePermission: sphere,
    emailPermission: email,
    spotPermission: spot,
    opicCodePermission: opicCode,
    soneparCodePermission: soneparCode,
    visualizeAllOrdersPermission: visualizeAllOrders,
    managerEmailPermission: managerEmail,
    allowMixedPurchase,
  };
}

export default setUserClient;
